
// Candle object for Candles overlay
import Tooltip from '../../../components/primitives/tooltip.js'

export default class MMCandle {

    constructor(overlay, ctx, layout, data, p1, p2, cmp) {
        this.ctx = ctx
        this.layout = layout
        this.self = overlay
        this.style = this.self
        this.top_imbalance_list = []
        this.bottom_imbalance_list = []
        this.cmp = cmp
        this.pTx = 0
        this.pTopTarget = 0
        this.pBx = 0
        this.pBottomTarget = 0

        let _data = (data);
        let _p1 = (p1);
        let _p2 = (p2);
        this._draw(_data, _p1, _p2, this.self, cmp)
    }

    convert_candle(data) {
        return {
           date: data.raw[0],
           o: data.raw[1],
           h: data.raw[2],
           l: data.raw[3],
           c: data.raw[4],
           v: data.raw[5],
           w: data.w,
           x: data.x
        };

        return data
    }

    _draw(data, p1, p2, self, cmp) {
        // Line width = 1 or 2?
        const line_width = this.style.lineWidth
        var up_hollow = this.style.upCandleHollow
        var down_hollow = this.style.downCandleHollow
        var imbalance = false
        var blackCandle = false

        //console.log("line_width", line_width)
        //console.log("up_hollow", up_hollow)

        var l = self.data.length

        var _data = this.convert_candle(data)
        var _p1 = this.convert_candle(p1)
        var _p2 = this.convert_candle(p2)

        const body_size = Math.abs(_p1.o - _p1.c)
        const candle_size = Math.abs(_p1.h - _p1.l)

        if (body_size <= (candle_size / 2)) {
            blackCandle = true
        } else {
            blackCandle = false
        }

        var top_imbalance = _p2.l <= _p1.o && _data.h >= _p1.c
        var top_imbalance_size = _p2.l - _data.h
        var bottom_imbalance = _p2.h >= _p1.o && _data.l <= _p1.c
        var bottom_imbalance_size = _data.l - _p2.h

        var body_border_color
        // bar color
        var body_color
        if (top_imbalance && top_imbalance_size > 0) {
            body_color =  this.style.downBodyColor
            body_border_color = this.style.downBarColor
            imbalance = true
            this.top_imbalance_list.push(_p1.o)
        }
        if (bottom_imbalance && bottom_imbalance_size > 0) {
            body_color = this.style.upBodyColor
            body_border_color = this.style.upBarColor
            imbalance = true
            this.bottom_imbalance_list.push(_p1.o)
        }

        if (blackCandle) {
            body_color = this.style.blackBarColor
        }

        for(var i = 0; i < this.top_imbalance_list.length; i++) {
            if (cmp > this.top_imbalance_list[i]) {
                var diff = this.top_imbalance_list[i] - cmp;
                if (_p1.topTargetDiff > diff) {
                    _p1.topTargetDiff = diff;
                    _p1.topTarget = this.top_imbalance_list[i];
                } else {
                    _p1.topTarget = this.top_imbalance_list[i];
                }
            }
        }

        for(var i = 0; i < this.bottom_imbalance_list.length; i++) {
            if (cmp < this.bottom_imbalance_list[i]) {
                var diff = cmp - this.bottom_imbalance_list[i] ;
                if (_p1.bottomTargetDiff < diff) {
                    _p1.bottomTargetDiff = diff;
                    _p1.bottomTarget = this.bottom_imbalance_list[i];
                } else {
                    _p1.bottomTarget = this.bottom_imbalance_list[i];
                }
            }
        }

        /*
        this.ctx.lineWidth = this.line_width
        this.ctx.strokeStyle = this.color
        this.ctx.beginPath()

        if (_p1.topTarget) {
            let x1 = this.pTx
            let y1 = this.layout.$2screen(this.pTopTarget)
            let x2 = _p1.x
            let y2 = this.layout.$2screen(_p1.topTarget)

            this.ctx.moveTo(x1, y1)
            this.ctx.lineTo(x2, y2)

            this.pTopTarget = _p1.topTarget
            this.pTx = _p1.x
        }
        if (_p1.bottomTarget) {
            let x1 = this.pBx
            let y1 = this.layout.$2screen(this.pBottomTarget)
            let x2 = _p1.x
            let y2 = this.layout.$2screen(_p1.bottomTarget)

            this.ctx.moveTo(x1, y1)
            this.ctx.lineTo(x2, y2)

            this.pBottomTarget = _p1.bottomTarget
            this.pBx = _p1.x
        }
        this.ctx.stroke()
        */

        let width = Math.max(p1.w, 1)
        let halfwidth = Math.max(Math.floor(width * 0.5), 1)
        let height = Math.abs(p1.o - p1.c)
        let max_h = p1.c === p1.o ? 1 : 2

        let line_width_half = line_width / 2

        if (imbalance) {
            // Draw the body
            if (p1.w > line_width + 0.5 || p1.o === p1.c) {
                // Draw a body as a rectangle if it is thick (>1.5).

                let hollow = false
                if (up_hollow && data.c <= data.o)
                    hollow = true

                if (hollow) {
                    this.ctx.strokeStyle = body_color
                    this.ctx.lineWidth = line_width
                    let s = p1.c >= p1.o ? 1 : -1
                    this.ctx.beginPath()
                    this.ctx.rect(
                        Math.floor(p1.x - halfwidth - line_width),
                        Math.floor(p1.o),
                        Math.floor(halfwidth * 2 + line_width),
                        Math.floor(s * Math.max(height, max_h))
                    )
                    this.ctx.stroke()
                } else {
                    this.ctx.fillStyle = body_color
                    this.ctx.strokeStyle = body_border_color
                    let s = p1.c >= p1.o ? 1 : -1
                    this.ctx.fillRect(
                        Math.floor(p1.x - halfwidth - line_width),
                        Math.floor(p1.o),
                        Math.floor(halfwidth * 2 + line_width),
                        Math.floor(s * Math.max(height, max_h))
                    )
                    this.ctx.lineWidth = 0.5
                    this.ctx.beginPath()
                    this.ctx.rect(
                        Math.floor(p1.x - halfwidth - line_width),
                        Math.floor(p1.o),
                        Math.floor(halfwidth * 2 + line_width),
                        Math.floor(s * Math.max(height, max_h))
                    )
                    this.ctx.stroke()

                    let w = this.ctx.measureText(_p1.o).width + 10

                    this.ctx.fillStyle = body_border_color
                    this.ctx.textAlign = 'left'
                    //this.ctx.fillText(_p1.o, _p1.x, this.layout.$2screen(_p1.o))
                }

            } else {
                // Draw a body as a line if it is too thin.
                // The line will be drawn of wick_width.

                this.ctx.strokeStyle = body_color
                this.ctx.lineWidth = line_width
                this.ctx.beginPath()
                this.ctx.moveTo(Math.floor(p1.x) - line_width_half, Math.floor(Math.min(p1.o, p1.c)),)
                this.ctx.lineTo(Math.floor(p1.x) - line_width_half, Math.floor(Math.max(p1.o, p1.c)),)
                this.ctx.stroke()

            }
        }
    }
}
